// filepath: src/App.js
import React from 'react';
import Header from './components/Header';
import MainSection from './components/MainSection';
import './App.css';
import logo from './assets/img/logo.svg';
import { useNavigate } from 'react-router-dom';

function App() {
  const navigate = useNavigate();
  const handleNavClick = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };
  const handleExternalLinkClick = (url) => (e) => {
    e.preventDefault();
    window.open(url, '_blank');
  };
  return (
    <div className="App">


      <header>
        <nav className="navbar navbar-expand-lg">
          <a href="#" onClick={handleNavClick('/')} className="navbar-brand">
            <img src={logo} alt="Logo" />
          </a>
          <button className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
            <span className="navbar-toggler-icon"><i className="fa-solid fa-bars"></i></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ml-auto">
              <li className="navbar-item">
                <a href="#" onClick={handleExternalLinkClick('https://www.indusind.com/in/en/personal.html#')} className="nav-link">Home</a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <MainSection />
    </div>
  );
}
export default App;